import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
    ChevronRight,
    Video,
    FileText
} from 'lucide-react';

const CoachSidebar = ({ isCollapsed, setIsCollapsed, onClose }) => {

    const navItems = [
        { to: "pending-video", icon: Video, label: "Video Queue" },
        { to: "reviewd-video", icon: FileText, label: "My Reviews" },
    ].filter(Boolean);

    return (
        <aside
            className={`
                flex flex-col bg-white shadow-xl z-40 transition-all duration-300 ease-in-out h-full
                lg:sticky lg:top-0 lg:h-screen lg:z-30
                ${isCollapsed ? 'w-20' : 'w-full lg:w-72'}
                flex
            `}
        >
            {/* Toggle Button (Desktop) */}
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="absolute -right-3 top-1/2 -translate-y-1/2 bg-white border border-gray-200 rounded-full p-1 shadow-md hover:bg-gray-50 text-gray-600 z-50 hidden lg:flex"
                style={{
                    transition: 'background-color 200ms ease, transform 200ms ease',
                }}
            >
                <span
                    style={{
                        display: 'flex',
                        transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                        transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                    }}
                >
                    <ChevronRight size={16} />
                </span>
            </button>

            {/* Navigation Links */}
            <div className={`flex-1 overflow-y-auto scrollbar-hide px-3 space-y-2 pb-8 ${isCollapsed ? 'pt-24' : 'pt-8 lg:pt-28'}`}>
                {!isCollapsed && (
                    <div className="px-4 mb-4">
                    </div>
                )}
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        onClick={() => onClose && onClose()}
                        className={({ isActive }) => `
                            sidebar-link
                            relative flex items-center gap-3 px-3 py-3 rounded-xl group transition-all duration-200
                            ${isActive ? 'bg-secondary-color !text-primary-color font-medium shadow-sm' : 'text-gray-600 hover:bg-secondary-color hover:!text-primary-color'}
                            ${isCollapsed ? 'justify-center' : ''}
                        `}
                    >
                        {({ isActive }) => (
                            <>
                                {/* Active Indicator Bar */}
                                <div className={`
                                    absolute left-0 top-1/2 -translate-y-1/2 w-1.5 h-7 bg-primary-color rounded-r-full transition-all duration-300 transform origin-left z-20
                                    ${isActive ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'}
                                `} />

                                <item.icon
                                    size={22}
                                    className={`flex-shrink-0 transition-colors duration-200 relative z-10 ${isActive ? '!text-primary-color' : 'text-gray-500 group-hover:!text-primary-color'}`}
                                />

                                {!isCollapsed && (
                                    <span className="whitespace-nowrap overflow-hidden transition-all duration-300 origin-left relative z-10">
                                        {item.label}
                                    </span>
                                )}
                            </>
                        )}
                    </NavLink>
                ))}
            </div>
        </aside>
    );
};

export default CoachSidebar;
